export enum TicketSource {
    MineApp = "MineApp",
    Form = "Form",
    Api = "Api",
    Manual = "Manual",
    EmailForwarding = "EmailForwarding",
    Import = "Import"
}